import React, { forwardRef } from 'react';

import { FlexItemProps } from './Flex.types';
import { getClassNames } from './FlexItem.styles';

const FlexItem = forwardRef<HTMLDivElement, FlexItemProps>(({ children, ariaHidden, role, ...styleProps }, ref) => {
  const classNames = getClassNames(styleProps);

  /**
   * This inline style is necessary to allow the minWidth prop to
   * override the higher-specificity style set by the <Flex> parent.
   */
  const style = styleProps.minWidth ? { minWidth: styleProps.minWidth } : undefined;

  return (
    <div className={classNames.flexItem} role={role} aria-hidden={ariaHidden} style={style} ref={ref}>
      {children}
    </div>
  );
});

FlexItem.displayName = 'FlexItem';

/**
 * A `FlexItem` component renders a div with flex-item styles.
 */
export default FlexItem;
